import { motion } from 'framer-motion';
import { Wrench, Clock, Mail } from 'lucide-react';
import { usePlatformSettings } from '@/hooks/usePlatformSettings';

export default function MaintenanceMode() {
  const { settings } = usePlatformSettings();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full text-center space-y-8"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
          className="w-20 h-20 mx-auto rounded-full bg-primary/10 flex items-center justify-center"
        >
          <Wrench className="w-10 h-10 text-primary" />
        </motion.div>

        <div className="space-y-4">
          <h1 className="text-3xl font-display font-bold text-foreground">
            We'll be right back
          </h1>
          
          <p className="text-muted-foreground">
            {settings.maintenance_message}
          </p>
        </div>

        <div className="flex items-center justify-center gap-6 text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4" />
            <span>Check back soon</span>
          </div>
          {settings.support_email && (
            <a
              href={`mailto:${settings.support_email}`}
              className="flex items-center gap-2 hover:text-foreground transition-colors"
            >
              <Mail className="w-4 h-4" />
              <span>Contact Support</span>
            </a>
          )}
        </div>

        <div className="pt-8 border-t border-border">
          <p className="text-xs text-muted-foreground">
            {settings.platform_name} • Maintenance Mode
          </p>
        </div>
      </motion.div>
    </div>
  );
}
